export default __webpack_public_path__ + "static/media/charity.37af8a2f.webp";